import React from "react";

import { AnalyticsChartType } from "@formant/core/model/AnalyticsChartType";
import { ISqlResult } from "@formant/core/model/ISqlResult";
import { primary } from "@formant/ui/component/common/Colors";

import { SelectField } from "../../common/SelectField";
import { Label } from "../../JsonSchemaForm/Label";
import { Spacer, SqlEditorForm } from "./EditAnalytisModule.styles";
import { SqlEditor } from "./SqlEditor";

interface IAdvancedEditorProps {
    showAdvanced: boolean;
    chartType: AnalyticsChartType;
    sqlText?: string;
    unit?: string;
    moduleId: string;
    deviceIds: string[];
    onSubmit: (_: string) => void;
    executeSqlString: (_: string) => Promise<ISqlResult | undefined>;
    onChangeUnit: (_: string) => void;
    children?: React.ReactNode;
}

export function AdvancedEditor(props: IAdvancedEditorProps) {
    const {
        chartType,
        showAdvanced,
        sqlText,
        onChangeUnit,
        unit,
        moduleId,
        onSubmit,
        executeSqlString,
        children,
        deviceIds,
    } = props;

    const handleChangeUnit = (event: React.ChangeEvent<HTMLSelectElement>) => {
        onChangeUnit(event.target.value);
    };

    if (!showAdvanced) {
        return null;
    }

    return (
        <>
            {chartType === "summary" && (
                <Spacer>
                    <SelectField
                        label="Unit"
                        value={unit}
                        onChange={handleChangeUnit}
                    >
                        <option value={undefined}>none</option>
                        {["percent"].map(_ => (
                            <option key={_} value={_}>
                                {_}
                            </option>
                        ))}
                    </SelectField>
                </Spacer>
            )}

            <Label
                value="SQL"
                uppercase={true}
                color={primary.silver}
                isTitle={false}
                link="https://docs.formant.io/docs/create-an-analytics-view-and-add-modules"
                description="Enter your own SQL query to customize your data set and visualization. You can start a query using the parameters above and then customize it here."
            />

            <SqlEditorForm>
                <SqlEditor
                    initialCode={sqlText || ""}
                    onSubmit={onSubmit}
                    uniqueId={moduleId}
                    executeSqlString={executeSqlString}
                    deviceIds={deviceIds}
                />
            </SqlEditorForm>

            {children}
        </>
    );
}
